import React, { useEffect } from "react";
import { CiClock1 } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { runbookExecutionHistoryActions } from "../../actions/runbookExecutionHistory.actions";
import Grid from "../common/Grid";
import Utils from "../../utils";
import StatusHelper from "../helpers/statusHelper";
import CollapsibleCard from "../common/CollapsibleCard";

function LatestExecutions({ hideTitle, ...props }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dashboardReducer = useSelector((state) => state.dashboard);

  const fetchLatestExecutions = () => {
    let queryParams = {
      clientId: props.user.clientId,
      clientGuid: props.user.clientGuid,
      pageSize: 10,
      pageNumber: 1,
    };
    dispatch(runbookExecutionHistoryActions.getLatestExecutions(queryParams));
  };

  useEffect(() => {
    fetchLatestExecutions();

    // Auto-refresh every 5 minutes (reduced from 1 minute for performance)
    const interval = setInterval(fetchLatestExecutions, 300000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [location]);

  const data = dashboardReducer.paginatedLatestExecutionsResult?.data.map(
    (r) => {
      return {
        ...r,
        executionDate: Utils.convertToDateTime(r.executionDate),
        status: StatusHelper.getBadge(r.status ?? "NotStarted"),
      };
    }
  );

  return (
    <div data-tour="latest-executions">
      <CollapsibleCard
        title="Latest Executions"
        icon={<CiClock1 className="mb-1" />}
        defaultExpanded={true}
        hideHeader={hideTitle}
      >
      <Grid
        data={data}
        displayColumns={[
          "runbookId",
          "runbookName",
          "executionDate",
          "status",
        ]}
        pageNumber={0}
        totalPages={data?.length ? 1 : 0}
        loading={dashboardReducer.loadingLatestExecutions}
        placeHolderLinesCount={6}
      ></Grid>
    </CollapsibleCard>
    </div>
  );
}

export default LatestExecutions;
